import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import { createReduxHistoryContext } from 'redux-first-history';
import reducer from './reducer';
import rootSaga from './saga';
import { bindHistory } from './historyInstance';

const browserHistory = createBrowserHistory();

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: browserHistory,
});

const sagaMiddleware = createSagaMiddleware();

const logger = createLogger({
    level: 'log',
    collapsed: true,
});

const enhancer = compose(applyMiddleware(logger, sagaMiddleware, routerMiddleware));

const initialState = {};

const store = createStore(reducer(routerReducer), initialState, enhancer);

export const history = createReduxHistory(store);
bindHistory(history);

sagaMiddleware.run(rootSaga);

export default store;
